module.exports = __webpack_public_path__ + "static/delivery-26a2d110096e66efd331aabf8bf8a082.png";